// @givmo/disclosure — the `409 DISCLOSURE_STALE` detector (Combined Plan 03 §8).
//
// The backend's pre-charge staleness gate (`DisclaimerDisclosureStaleException`) rejects a donation
// whose echoed `shown_disclaimer_version_id`/`content_hash` no longer matches the disclaimer the
// server currently resolves — a counsel revision landed mid-flight. The 409 fires BEFORE the
// charge (no money moves); the client re-resolves, re-renders, and the donor re-confirms.
//
// Wire shape (`app/api/errorhandling.py` `handle_disclaimer_disclosure_stale`):
//   409 `{errors:[{code: 409, title: "DISCLOSURE_STALE", detail: "The disclosure has been
//   updated. …", request_id}]}`
// The envelope `title` is the branch key — the handler emits no machine `error_code` field.

import { isGivmoError } from '@givmo/api-client';

/** The backend envelope `title` for the pre-charge disclosure staleness gate. */
export const DISCLOSURE_STALE_TITLE = 'DISCLOSURE_STALE';

/**
 * Whether an error is the pre-charge `409 DISCLOSURE_STALE` gate rejection. Strict on both the
 * status AND the envelope title so a generic 409 (e.g. an idempotency conflict) never triggers the
 * re-resolve → re-confirm flow.
 */
export function isDisclosureStaleError(error: unknown): boolean {
  if (!isGivmoError(error)) return false;
  if (error.status !== 409) return false;
  return error.entries.some((entry) => entry.title === DISCLOSURE_STALE_TITLE);
}
